import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../../shared/components/ui/cta-button/cta-button.component';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-course-card',
  standalone: true,
  imports: [TranslatePipe, CtaButtonComponent, MatProgressSpinnerModule],
  templateUrl: './course-card.component.html',
  styleUrl: './course-card.component.scss',
})
export class CourseCardComponent {
  course = input.required<ChallengeGen.Course>();
  statusLabel = input.required<(status: string) => string>();
  sourceLabel = input.required<(source: string) => string>();
  hasHeroImage = input.required<(course: ChallengeGen.Course) => boolean>();
  showHeroSpinner = input.required<(course: ChallengeGen.Course) => boolean>();

  openCourse = output<ChallengeGen.Course>();
  imageError = output<string>();

  onImageError(courseId: string): void {
    this.imageError.emit(courseId);
  }
}
